import { batch, computed, signal } from "@preact/signals-react"

// Table data
export const tableData = signal([])
export const totalCount = signal(0)
export const currentPage = signal(0)
export const pageSize = signal(20)

// Stats data
export const statsData = signal(null)
export const isLoadingStats = signal(false)

// Map drawer
export const mapDrawerProduct = signal(null)

// Match compare modal: { product, matches, index }
export const matchCompareModal = signal(null)

// Loading states
export const isLoadingFilters = signal(false)
export const isLoadingTable = signal(false)

// Filters
export const selectedCustomer = signal(null) // {value, label}
export const selectedSites = signal([])
export const selectedBrands = signal([])
export const searchText = signal('')
export const onlyUnmatched = signal(false)
export const onlySuspicious = signal(false)
export const compareSite = signal(null) // {value: id_site, label: name} — single site to compare against

// Recent data filter (by last_seen date) - enabled by default, 30 days
export const recentDataEnabled = signal(false)
export const recentDataDays = signal(30)
export const recentDataDateFrom = signal(null)
export const recentDataDateTo = signal(null)

// Only new products filter (by created_at)
export const onlyNewProducts = signal(false)
export const newProductsDateFrom = signal(null)
export const newProductsDateTo = signal(null)

export const filtersValue = computed(() => ({
    id_customer: selectedCustomer.value?.value || null,
    sites: selectedSites.value.map(s => s.value) || [],
    brands: selectedBrands.value.map(b => b.value) || [],
    text: searchText.value || '',
    recent_data_enabled: recentDataEnabled.value,
    recent_data_days: recentDataDays.value,
    recent_data_from: recentDataDateFrom.value || null,
    recent_data_to: recentDataDateTo.value || null,
    only_new: onlyNewProducts.value,
    new_products_from: newProductsDateFrom.value || null,
    new_products_to: newProductsDateTo.value || null,
    compare_site: compareSite.value?.value || null,
}))

export const tableFiltersValue = computed(() => ({
    ...filtersValue.value,
    only_unmatched: onlyUnmatched.value,
    only_suspicious: onlySuspicious.value
}))

export const canSearch = computed(() =>
    selectedCustomer.value !== null
)

export const clearRetailerProductsSignals = () => batch(() => {
    tableData.value = []
    totalCount.value = 0
    currentPage.value = 0
    pageSize.value = 20
    isLoadingFilters.value = false
    isLoadingTable.value = false
    isLoadingStats.value = false
    statsData.value = null
    selectedCustomer.value = null
    selectedSites.value = []
    selectedBrands.value = []
    searchText.value = ''
    onlyUnmatched.value = false
    onlySuspicious.value = false
    compareSite.value = null
    recentDataEnabled.value = false
    recentDataDays.value = 30
    recentDataDateFrom.value = null
    recentDataDateTo.value = null
    mapDrawerProduct.value = null
    matchCompareModal.value = null
    onlyNewProducts.value = false
    newProductsDateFrom.value = null
    newProductsDateTo.value = null
})
